export default __webpack_public_path__ + "static/media/vili_xl.b58f9602.jpg";